import { render, staticRenderFns } from "./IframeTest.vue?vue&type=template&id=5bb36a66&"
import script from "./IframeTest.vue?vue&type=script&lang=js&"
export * from "./IframeTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports